// extracted by mini-css-extract-plugin
export var arrowIcon = "styles-module--arrowIcon--e04c8";
export var back = "styles-module--back--7df5d";
export var button = "styles-module--button--b6b80";
export var content = "styles-module--content--8640a";
export var graphic = "styles-module--graphic--4ef58";
export var title = "styles-module--title--96e7d";
export var visible = "styles-module--visible--993c7";